import React from "react";
var __jsx = React.createElement;
import OfferCarsV2 from "./OfferCarsV2";
var OffersWrapperV2 = function OffersWrapperV2(_ref) {
  var isNew = _ref.isNew,
    title = _ref.title,
    deals = _ref.deals;
  return /*#__PURE__*/React.createElement(OfferCarsV2, {
    isNew: isNew,
    title: title,
    offers: deals.posts
  });
};
export default OffersWrapperV2;